import { Feature } from "ol";
import LineString from "ol/geom/LineString";

export default class LineStringFeature extends Feature<LineString> {
    getGeometry(): LineString {
        return super.getGeometry()!
    }
}